import {Component, Input} from '@angular/core';
import {IGlobalError} from '../../models/global-error';
import {SerializationUtils} from '../../../../../shared-module-ui/utils';

@Component({
    selector: 'app-global-error-display',
    templateUrl: './global-error-display.component.html',
    styleUrls: ['./global-error-display.component.scss'],
    standalone: false
})
export class GlobalErrorDisplayComponent {

  #actionParsed: Record<string, string | { 'type': unknown; }> = undefined;

  #globalError: IGlobalError = undefined;
  #isMessageAccordionOpen = false;
  #isPayloadAccordionOpen = false;

  get errorAction(): string {
    return this.globalErrorInstance.action;
  }

  get errorActionParsed(): Record<string, string | { type: unknown; }> {
    return this.#actionParsed;
  }

  get errorActionParsedPayload(): Record<string, string> | undefined {
    const payload = this.errorActionParsed?.['payload'];
    if (typeof payload === 'object' && payload !== null && !Array.isArray(payload)) {
      return payload as Record<string, string>;
    }
    return undefined;
  }

  get errorActionParsedArray(): { key: string; value: unknown }[] {
    const payload = this.errorActionParsedPayload;
    if (!payload) return [];
    return Object.entries(payload).map(([key, value]) => ({
      key,
      value,
    }));
  }

  get globalErrorInstance(): IGlobalError {
    return this.#globalError;
  }

  get errorMessage(): string {
    return this.globalErrorInstance.message;
  }

  get errorName(): string {
    return this.globalErrorInstance.name;
  }

  get isMessageAccordionOpened(): boolean {
    return this.#isMessageAccordionOpen;
  }

  get isPayloadAccordionOpened(): boolean {
    return this.#isPayloadAccordionOpen;
  }

  @Input() set globalError(globalError: IGlobalError) {
    if (globalError) {
      this.#globalError = globalError;
      this.#actionParsed = SerializationUtils.movePropertiesToPayload(globalError.action, ['type']);
    }
  }

  set isMessageAccordionOpened(open: boolean) {
    this.#isMessageAccordionOpen = open;
  }

  set isPayloadAccordionOpened(open: boolean) {
    this.#isPayloadAccordionOpen = open;
  }

  trackByItemProperty(index: number, item: Record<string, unknown>): string {
    return Object.keys(item)[0];
  }

}
